
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1e7e"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1e7e"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bxa0x", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $865a8a16446988ab$export$6503ec6e8aabbaf; }, function (v) { return $865a8a16446988ab$export$6503ec6e8aabbaf = v; });
var $865a8a16446988ab$export$6503ec6e8aabbaf;
var $865a8a16446988ab$export$f7ad0328861e2f03;
"use strict";
var $865a8a16446988ab$var$mapping = new Map();
function $865a8a16446988ab$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$865a8a16446988ab$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $865a8a16446988ab$var$resolve(id) {
    var resolved = $865a8a16446988ab$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$865a8a16446988ab$export$6503ec6e8aabbaf = $865a8a16446988ab$var$register;
$865a8a16446988ab$export$f7ad0328861e2f03 = $865a8a16446988ab$var$resolve;

});

parcelRegister("236OM", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $17e12686bf321de3$export$bdfd709ae4826697; }, function (v) { return $17e12686bf321de3$export$bdfd709ae4826697 = v; });
$parcel$export(module.exports, "getOrigin", function () { return $17e12686bf321de3$export$5a759dc7a1cfb72a; }, function (v) { return $17e12686bf321de3$export$5a759dc7a1cfb72a = v; });
var $17e12686bf321de3$export$bdfd709ae4826697;
var $17e12686bf321de3$export$c9e73fbda7da57b6;
var $17e12686bf321de3$export$5a759dc7a1cfb72a;
"use strict";
var $17e12686bf321de3$var$bundleURL = {};
function $17e12686bf321de3$var$getBundleURLCached(id) {
    var value = $17e12686bf321de3$var$bundleURL[id];
    if (!value) {
        value = $17e12686bf321de3$var$getBundleURL();
        $17e12686bf321de3$var$bundleURL[id] = value;
    }
    return value;
}
function $17e12686bf321de3$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $17e12686bf321de3$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $17e12686bf321de3$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $17e12686bf321de3$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$17e12686bf321de3$export$bdfd709ae4826697 = $17e12686bf321de3$var$getBundleURLCached;
$17e12686bf321de3$export$c9e73fbda7da57b6 = $17e12686bf321de3$var$getBaseURL;
$17e12686bf321de3$export$5a759dc7a1cfb72a = $17e12686bf321de3$var$getOrigin;

});

parcelRegister("hbluw", function(module, exports) {

$parcel$export(module.exports, "ENDPOINT", function () { return $c82422755965d529$export$1a23c4610ef05bed; });
$parcel$export(module.exports, "UPLOAD_ENDPOINT", function () { return $c82422755965d529$export$cdda3773e71b07e4; });
const $c82422755965d529$var$MODE = "DEV" // 'DEV', 'STAGE', 'PROD'
;
const $c82422755965d529$var$ENVIRONMENTS = {
    PROD: {
        ENDPOINT: "https://hiaudio.fr",
        UPLOAD_ENDPOINT: "https://hiaudio.fr/fileUpload"
    },
    STAGE: {
        ENDPOINT: window.location.protocol + "//" + window.location.host,
        UPLOAD_ENDPOINT: window.location.protocol + "//" + window.location.host + "/fileUpload"
    },
    DEV: {
        ENDPOINT: window.location.protocol + "//" + window.location.host,
        UPLOAD_ENDPOINT: window.location.protocol + "//" + window.location.host + "/fileUpload"
    }
};
const $c82422755965d529$export$1a23c4610ef05bed = $c82422755965d529$var$ENVIRONMENTS[$c82422755965d529$var$MODE].ENDPOINT;
const $c82422755965d529$export$cdda3773e71b07e4 = $c82422755965d529$var$ENVIRONMENTS[$c82422755965d529$var$MODE].UPLOAD_ENDPOINT;

});

parcelRegister("gXFaz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c592176fe54591c6$export$2e2bcd8739ae039; });
class $c592176fe54591c6$var$DynamicModal {
    dynamicModalDialog(message, idbtn, textBtnOK, textBtnCancel, popupTitle, backgroundHeader, callbackDismiss) {
        const html = '<div class="modal-header ' + backgroundHeader + ' text-white">' + '<h5 class="modal-title" id="dynamicModalLabel">' + popupTitle + "</h5>" + '<button type="button" class="close" data-dismiss="modal" aria-label="Close">' + '<span aria-hidden="true">&times;</span>' + "</button>" + "</div>" + '<div class="modal-body">' + message + "</div>" + '<div class="modal-footer">' + '<button type="button" class="btn btn-secondary" data-dismiss="modal">' + textBtnCancel + "</button>" + (idbtn !== null ? "<button id=" + idbtn + ' type="button" class="btn btn-primary">' + textBtnOK + "</button>" : "") + "</div>";
        this.setDynamicModalContent(html);
        this.callbackDismiss = callbackDismiss;
        $(this.modal).modal("show");
    }
    getDynamicModal() {
        return document.getElementById("dynamicModal");
    }
    setDynamicModalContent(html) {
        this.modal.querySelector(".modal-content").innerHTML = html;
    }
    closeDynamicModal(callBackClose) {
        $(this.modal).modal("hide");
        if (callBackClose) callBackClose();
    }
    initDynamicModal() {
        const modal = document.createElement("div");
        modal.classList.add("modal", "fade");
        modal.setAttribute("id", "dynamicModal");
        modal.setAttribute("tabindex", "-1");
        modal.setAttribute("role", "dialog");
        modal.setAttribute("aria-labelledby", "dynamicModalLabel");
        modal.setAttribute("aria-hidden", "true");
        modal.innerHTML = '<div class="modal-dialog modal-sm modal-dialog-centered" role="document"><div class="modal-content"></div></div>';
        document.body.appendChild(modal);
        return modal;
    }
    constructor(){
        this.modal = this.getDynamicModal();
        this.callbackDismiss = null;
        if (!this.modal) {
            this.modal = this.initDynamicModal();
            const self = this;
            $(this.modal).on("hide.bs.modal", function(event) {
                if (self.callbackDismiss) {
                    self.callbackDismiss();
                    self.callbackDismiss = null;
                }
            });
        }
    }
}
const $c592176fe54591c6$var$dynamicModalInstance = new $c592176fe54591c6$var$DynamicModal();
var $c592176fe54591c6$export$2e2bcd8739ae039 = $c592176fe54591c6$var$dynamicModalInstance;

});

parcelRegister("jXEky", function(module, exports) {

$parcel$export(module.exports, "uriUserPage", function () { return $e882cfcc4184df66$export$ff3ad29dbb546598; });
$parcel$export(module.exports, "uriCollectionPage", function () { return $e882cfcc4184df66$export$36dfaec04418caa7; });
$parcel$export(module.exports, "UserRole", function () { return $e882cfcc4184df66$export$eb3485a690c2f0b8; });
$parcel$export(module.exports, "LevelPrivacy", function () { return $e882cfcc4184df66$export$a3c073b335a47d60; });
$parcel$export(module.exports, "PRIVACY_BADGE_STYLE", function () { return $e882cfcc4184df66$export$eba8c17f4d7a3cd3; });
$parcel$export(module.exports, "PRIVACY_BADGE_TEXT", function () { return $e882cfcc4184df66$export$ab4fdfae3dcd1a8f; });
$parcel$export(module.exports, "ROLE_BADGE_STYLE", function () { return $e882cfcc4184df66$export$f25eef55c66a4e9d; });
$parcel$export(module.exports, "startLoader", function () { return $e882cfcc4184df66$export$8afc507ca675ea0e; });
$parcel$export(module.exports, "cancelLoader", function () { return $e882cfcc4184df66$export$81e46b314cb8d8e3; });
$parcel$export(module.exports, "callJsonApi", function () { return $e882cfcc4184df66$export$997d30e836e5c567; });
$parcel$export(module.exports, "looksLikeMail", function () { return $e882cfcc4184df66$export$706cf9fcefe67c8e; });
$parcel$export(module.exports, "activateGoHomeLink", function () { return $e882cfcc4184df66$export$3fc781af82c0c660; });
$parcel$export(module.exports, "MEDIA_CONSTRAINTS", function () { return $e882cfcc4184df66$export$2464c9e69777d386; });

var $hbluw = parcelRequire("hbluw");
const $e882cfcc4184df66$export$ff3ad29dbb546598 = "/index.html?userid=";
const $e882cfcc4184df66$export$36dfaec04418caa7 = "/index.html?collectionid=";
const $e882cfcc4184df66$export$eb3485a690c2f0b8 = Object.freeze({
    none: 0,
    owner: 1,
    admin: 2,
    member: 3,
    guest: 4
});
const $e882cfcc4184df66$export$a3c073b335a47d60 = Object.freeze({
    public: 1,
    onlyreg: 2,
    private: 3
});
const $e882cfcc4184df66$export$eba8c17f4d7a3cd3 = {
    [$e882cfcc4184df66$export$a3c073b335a47d60.public]: "badge-public",
    [$e882cfcc4184df66$export$a3c073b335a47d60.onlyreg]: "badge-onlyreg",
    [$e882cfcc4184df66$export$a3c073b335a47d60.private]: "badge-private"
};
const $e882cfcc4184df66$export$ab4fdfae3dcd1a8f = {
    [$e882cfcc4184df66$export$a3c073b335a47d60.public]: "PUBLIC",
    [$e882cfcc4184df66$export$a3c073b335a47d60.onlyreg]: "REG USERS",
    [$e882cfcc4184df66$export$a3c073b335a47d60.private]: "PRIVATE"
};
const $e882cfcc4184df66$export$f25eef55c66a4e9d = {
    [$e882cfcc4184df66$export$eb3485a690c2f0b8.owner]: "badge-owner",
    [$e882cfcc4184df66$export$eb3485a690c2f0b8.admin]: "badge-admin",
    [$e882cfcc4184df66$export$eb3485a690c2f0b8.member]: "badge-member",
    [$e882cfcc4184df66$export$eb3485a690c2f0b8.guest]: "badge-guest"
};
const $e882cfcc4184df66$export$8afc507ca675ea0e = (loadingMessage)=>{
    const loaderElement = document.getElementById("loader");
    loaderElement.innerHTML = `<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>&nbsp;${loadingMessage}`;
    loaderElement.classList.remove("loader-hidden");
};
const $e882cfcc4184df66$export$81e46b314cb8d8e3 = ()=>{
    const loaderElement = document.getElementById("loader");
    loaderElement.classList.add("loader-hidden");
};
const $e882cfcc4184df66$export$997d30e836e5c567 = async (apimethod, rqstmethod, body, useLoaderWithText)=>{
    const request = {
        method: rqstmethod || "GET",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    };
    if (body) request.body = JSON.stringify(body);
    try {
        useLoaderWithText && $e882cfcc4184df66$export$8afc507ca675ea0e(useLoaderWithText);
        const sendRqst = await fetch((0, $hbluw.ENDPOINT) + apimethod, request);
        useLoaderWithText && $e882cfcc4184df66$export$81e46b314cb8d8e3();
        const respToJson = await sendRqst.json();
        if (respToJson && !respToJson.error) return respToJson;
        else return (respToJson === null || respToJson === void 0 ? void 0 : respToJson.error) || "An error occurred";
    } catch (error) {
        useLoaderWithText && $e882cfcc4184df66$export$81e46b314cb8d8e3();
        return error;
    }
};
const $e882cfcc4184df66$export$706cf9fcefe67c8e = (str)=>{
    const lastAtPos = str.lastIndexOf("@");
    const lastDotPos = str.lastIndexOf(".");
    return lastAtPos < lastDotPos && lastAtPos > 0 && str.indexOf("@@") == -1 && lastDotPos > 2 && str.length - lastDotPos > 2;
};
const $e882cfcc4184df66$export$3fc781af82c0c660 = ()=>{
    const goHomeLink = document.getElementById("goHome");
    if (window.location.host === "localhost:80" || window.location.origin === "http://localhost") goHomeLink.href = window.location.origin + "/index.html";
    else goHomeLink.href = window.location.origin;
};
const $e882cfcc4184df66$export$95df08bae54cb4df = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
const $e882cfcc4184df66$export$2464c9e69777d386 = {
    audio: {
        echoCancellation: false,
        noiseSuppression: false,
        autoGainControl: false,
        latency: 0,
        channelCount: 1
    }
};

});

parcelRegister("faZmx", function(module, exports) {

$parcel$export(module.exports, "checkIfTermsAccepted", function () { return $b0c76387600d0ed6$export$207bec4913bdffa6; });
$parcel$export(module.exports, "generateAcceptTermsModal", function () { return $b0c76387600d0ed6$export$7ed6abee26b8c64b; });

var $jXEky = parcelRequire("jXEky");
const $b0c76387600d0ed6$export$207bec4913bdffa6 = (userprofile, callback)=>{
    (0, $jXEky.cancelLoader)();
    callback(userprofile === null || userprofile === void 0 ? void 0 : userprofile.terms_accepted);
};
const $b0c76387600d0ed6$export$95d7694256f75341 = ()=>{
    $("#acceptTermsModal").modal({
        backdrop: "static",
        keyboard: false // to prevent closing with Esc button (if you want this too)
    });
    $("#acceptTermsModal").modal("show");
    document.getElementById("buttonAcceptTerms").onclick = $b0c76387600d0ed6$var$rqstAcceptTerms;
    document.getElementById("buttonRejectTerms").onclick = $b0c76387600d0ed6$var$rqstRejectTerms;
};
const $b0c76387600d0ed6$var$rqstAcceptTerms = async ()=>{
    const data = await (0, $jXEky.callJsonApi)("/acceptterms", "PUT", null, "Welcome...");
    if (data.ok) $("#acceptTermsModal").modal("hide");
};
const $b0c76387600d0ed6$var$rqstRejectTerms = async ()=>{
    const data = await (0, $jXEky.callJsonApi)("/rejectterms", "PUT", null, "Deleting information...");
    if (data.ok) {
        $("#acceptTermsModal").modal("hide");
        window.location.href = window.location.origin;
    }
};
const $b0c76387600d0ed6$export$7ed6abee26b8c64b = (attachToElem)=>{
    const isModal = document.getElementById("acceptTermsModal");
    if (!isModal) {
        const modalDialog = `<div class="modal fade" id="acceptTermsModal" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                <h5 class="modal-title">Accept Terms</h5>                
                </div>
                <div class="modal-body">
                <p>By clicking on OK you accept the Terms of Use.</p>
                <p>More information at: <span> <a href="${window.location.origin}/static/terms.html" target="_blank">${window.location.origin}/static/terms.html</a></span></p>
                </div>
                <div class="modal-footer">
                <button id="buttonRejectTerms" type="button" class="btn btn-secondary" data-dismiss="modal">Reject</button>
                <button id="buttonAcceptTerms" type="button" class="btn btn-primary">OK</button>
                </div>
            </div>
            </div>
        </div>`;
        document.getElementsByTagName(attachToElem)[0].insertAdjacentHTML("afterend", modalDialog);
    }
    $b0c76387600d0ed6$export$95d7694256f75341();
};

});

parcelRegister("fZ0Rm", function(module, exports) {

$parcel$export(module.exports, "getCollections", function () { return $ba2d383e494f9e86$export$a9dbfb18603d6a77; });
$parcel$export(module.exports, "getCollectionsError", function () { return $ba2d383e494f9e86$export$66d4708c2e689cee; });
$parcel$export(module.exports, "createListCollections", function () { return $ba2d383e494f9e86$export$5a676dd14dd0be2c; });

var $hbluw = parcelRequire("hbluw");

var $gXFaz = parcelRequire("gXFaz");
const $ba2d383e494f9e86$export$a9dbfb18603d6a77 = async ()=>{
    const response = await fetch((0, $hbluw.ENDPOINT) + "/mycollections");
    let result = null;
    if (response === null || response === void 0 ? void 0 : response.ok) {
        const respJson = await response.json();
        result = respJson;
    }
    return result;
};
const $ba2d383e494f9e86$export$66d4708c2e689cee = ()=>{
    (0, $gXFaz.default).dynamicModalDialog("Problem getting collections", null, "", "Close", "Error", "bg-danger");
};
const $ba2d383e494f9e86$export$5a676dd14dd0be2c = (collections, listId, coll_id)=>{
    const theList = collections.all_collections;
    const listCollContainer = document.getElementById(listId);
    let listOptions = `<option value='0'>...</option>`;
    let selected = null;
    theList.forEach((element)=>{
        if (element) {
            if (element.uuid === coll_id) selected = "selected>";
            else selected = null;
            const template = `<option value='${element.uuid}' ${selected ? selected : ">"}${element.title}</option>`;
            listOptions += template;
        }
    });
    const listElelemts = `<select class='custom-select' id='inputGroupSelectCollect'>${listOptions}</select>`;
    listCollContainer.insertAdjacentHTML("afterbegin", listElelemts);
};

});

var $e930bf9cbf680b1d$exports = {};


(parcelRequire("bxa0x")).register((parcelRequire("236OM")).getBundleURL("51AM1"), JSON.parse('["51AM1","index.4020d3ca.js","fZrLJ","compress_home_page_video.e4cc210b.mp4"]'));


var $hbluw = parcelRequire("hbluw");

var $gXFaz = parcelRequire("gXFaz");

var $jXEky = parcelRequire("jXEky");

var $jXEky = parcelRequire("jXEky");

const $a57243222c2ea8a4$export$184163c68675dcce = (isauth, isuserorcollection)=>{
    $a57243222c2ea8a4$var$createBreadCrumbNavBar(isauth, isuserorcollection);
    document.querySelectorAll(".breadcrumb-item a").forEach(function(element) {
        element.addEventListener("click", function(event) {
            var _document_querySelector;
            event.preventDefault();
            (_document_querySelector = document.querySelector(".active-breadcrumb")) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.classList.remove("active-breadcrumb");
            event.currentTarget.classList.add("active-breadcrumb");
            let section = event.currentTarget.getAttribute("data-section");
            $a57243222c2ea8a4$export$ff7962acd6052c28(section, isauth);
        });
    });
};
const $a57243222c2ea8a4$var$createBreadCrumbNavBar = (isauth, isuserorcollection)=>{
    const navBar = document.getElementById("breadcrumbnavbar");
    let userOptions = "";
    if (isauth.ok) userOptions = `<li class='breadcrumb-item ${isuserorcollection ? "" : "active-breadcrumb"}' aria-current='page'><a href='#' data-section='my-comp'>My Music</a></li>
        <li class='breadcrumb-item'><a href='#' data-section='all-comp'>All</a></li>`;
    else userOptions = `<li class='breadcrumb-item ${isuserorcollection ? "" : "active-breadcrumb"}' aria-current='page'><a href='#' data-section='recent-comp'>Recent</a></li>
        <li class='breadcrumb-item'><a href='#' data-section='all-comp'>All</a></li>`;
    navBar.innerHTML = userOptions;
};
function $a57243222c2ea8a4$export$ff7962acd6052c28(section, isauth) {
    const url = new URL(window.location.href);
    url.searchParams.delete("userid");
    url.searchParams.delete("collectionid");
    history.replaceState(null, null, url);
    let withScroll = false;
    switch(section){
        case "recent-comp":
            withScroll = true;
            (0, $ce4a593b0ea78dcf$export$8d85b36da8527a05)(withScroll);
            break;
        case "my-comp":
            (0, $ce4a593b0ea78dcf$export$b99e48ec291af6c0)();
            break;
        case "all-comp":
            document.getElementById("initialmessage").classList.remove("d-flex");
            document.getElementById("initialmessage").hidden = true;
            if (!isauth.ok) withScroll = true;
            (0, $ce4a593b0ea78dcf$export$556539c2d93a797d)(withScroll);
            break;
        default:
            console.log("section default");
    }
}



var $faZmx = parcelRequire("faZmx");

let $69dccf2381da1e7e$var$_USERNAME = null;
const $69dccf2381da1e7e$export$1badf4b56a2f2c08 = (endpoint)=>{
    let result = false;
    if (endpoint === "/mycompositions" || endpoint.includes("/compositionsbyuserid/") || endpoint.includes("/collectionastreebyid/")) result = true;
    return result;
};
const $69dccf2381da1e7e$var$getCurrentUserName = ()=>{
    return $69dccf2381da1e7e$var$_USERNAME;
};
const $69dccf2381da1e7e$export$149136365741a43c = (username)=>{
    $69dccf2381da1e7e$var$_USERNAME = username;
};
const $69dccf2381da1e7e$export$a04c3fad920d835e = (endpoint, username)=>{
    let displayName = false;
    if (!$69dccf2381da1e7e$export$1badf4b56a2f2c08(endpoint)) displayName = true;
    else displayName = username !== $69dccf2381da1e7e$var$getCurrentUserName();
    return displayName;
};
const $69dccf2381da1e7e$var$getGroupsByCollAndUser = (compositionsList)=>{
    const groupedbycoll = {};
    const groupedbyuser_aux = {};
    compositionsList.forEach((composition)=>{
        const collectionId = composition.collection_uid;
        const userId = composition.user_id;
        if (collectionId !== null) {
            if (!groupedbycoll[collectionId]) groupedbycoll[collectionId] = [];
            groupedbycoll[collectionId].push(composition);
        } else {
            if (!groupedbyuser_aux[userId]) groupedbyuser_aux[userId] = [];
            groupedbyuser_aux[userId].push(composition);
        }
    });
    return {
        groupedbycoll: groupedbycoll,
        groupedbyuser_aux: groupedbyuser_aux
    };
};
const $69dccf2381da1e7e$var$getGroupsByCollectionAndSubColl = (compositionsList, parent_coll_id)=>{
    const groupedbycoll = {};
    const singlecomps = [];
    compositionsList.forEach((composition)=>{
        const collectionId = composition.collection_uid;
        if (collectionId !== null && collectionId !== parent_coll_id) {
            if (!groupedbycoll[collectionId]) groupedbycoll[collectionId] = [];
            groupedbycoll[collectionId].push(composition);
        } else singlecomps.push(composition);
    });
    return {
        groupedbycoll: groupedbycoll,
        singlecomps: singlecomps
    };
};
const $69dccf2381da1e7e$var$getGroupsByCollAndCollab = (compositionsList)=>{
    const groupedbycoll = {};
    const groupedbycollab = {};
    const singlecomps = [];
    compositionsList.forEach((composition)=>{
        const collectionId = composition.collection_uid;
        if (collectionId !== null) {
            if (!groupedbycoll[collectionId]) groupedbycoll[collectionId] = [];
            groupedbycoll[collectionId].push(composition);
        } else if (composition.contributors.length) {
            if (!groupedbycollab["collabs"]) groupedbycollab["collabs"] = [];
            groupedbycollab["collabs"].push(composition);
        } else singlecomps.push(composition);
    });
    return {
        groupedbycoll: groupedbycoll,
        groupedbycollab: groupedbycollab,
        singlecomps: singlecomps
    };
};
// INFO: a group for a User is made if he has 2 or more compositions without Collection
const $69dccf2381da1e7e$var$getFinalGroupByUserAndSingleComp = (groupedbyuser_aux)=>{
    const groupedbyuser_final = {};
    const singlecomps = [];
    for(const elem in groupedbyuser_aux)if (groupedbyuser_aux[elem].length === 1) singlecomps.push(groupedbyuser_aux[elem][0]);
    else {
        if (!groupedbyuser_final[elem]) groupedbyuser_final[elem] = [];
        groupedbyuser_final[elem] = groupedbyuser_aux[elem];
    }
    return {
        singlecomps: singlecomps,
        groupedbyuser_final: groupedbyuser_final
    };
};
const $69dccf2381da1e7e$export$2095d3815b0f7547 = (compositionsList)=>{
    const { groupedbycoll: groupedbycoll, groupedbyuser_aux: groupedbyuser_aux } = $69dccf2381da1e7e$var$getGroupsByCollAndUser(compositionsList);
    const { singlecomps: singlecomps, groupedbyuser_final: groupedbyuser_final } = $69dccf2381da1e7e$var$getFinalGroupByUserAndSingleComp(groupedbyuser_aux);
    return {
        groupedbycoll: groupedbycoll,
        groupedbyuser_final: groupedbyuser_final,
        singlecomps: singlecomps
    };
};
const $69dccf2381da1e7e$export$6d37f804b553eac7 = (compositionsList)=>{
    const { groupedbycoll: groupedbycoll, groupedbycollab: groupedbycollab, singlecomps: singlecomps } = $69dccf2381da1e7e$var$getGroupsByCollAndCollab(compositionsList);
    return {
        groupedbycoll: groupedbycoll,
        groupedbycollab: groupedbycollab,
        singlecomps: singlecomps
    };
};
const $69dccf2381da1e7e$export$46ab7a802f6f7711 = (compositionsList, parent_coll_id)=>{
    const { groupedbycoll: groupedbycoll, singlecomps: singlecomps } = $69dccf2381da1e7e$var$getGroupsByCollectionAndSubColl(compositionsList, parent_coll_id);
    return {
        groupedbycoll: groupedbycoll,
        singlecomps: singlecomps
    };
};
const $69dccf2381da1e7e$export$3763f15547b21628 = (compositionsList)=>{
    const tracksList = [];
    const compositionsDictionary = {};
    const tracksDictionary = {};
    compositionsList.forEach((composition)=>{
        compositionsDictionary[composition.uuid] = composition;
        if (composition === null || composition === void 0 ? void 0 : composition.tracks.length) {
            for(let i = 0; i < composition.tracks.length; i++){
                const currentTrack = composition.tracks[i];
                currentTrack["comp_uuid"] = composition.uuid;
                tracksDictionary[currentTrack.uuid] = currentTrack;
            }
            tracksList.push(...composition.tracks);
        }
    });
    return {
        tracksList: tracksList,
        compositionsDictionary: compositionsDictionary,
        tracksDictionary: tracksDictionary
    };
};



var $jXEky = parcelRequire("jXEky");
var $0ecf9681af59aef9$exports = {};

$0ecf9681af59aef9$exports = (parcelRequire("236OM")).getBundleURL("51AM1") + "compress_home_page_video.e4cc210b.mp4";


const $ceab237e06e82e44$var$homeVideoUrl = new URL($0ecf9681af59aef9$exports);
const $ceab237e06e82e44$var$CARD_BADGE_STYLE = {
    "coll": "badge-collection",
    "user": "badge-warning",
    "collab": "badge-collab"
};
const $ceab237e06e82e44$var$CARD_BORDER_STYLE = {
    "coll": "border-collection",
    "user": "border-warning",
    "collab": "border-collab"
};
const $ceab237e06e82e44$var$URI_PAGE = {
    "coll": (0, $jXEky.uriCollectionPage),
    "user": (0, $jXEky.uriUserPage)
};
//const WELCOME_TEXT = 'We present Hi-Audio Online Platform a web application for musicians, researchers and an open community of enthusiasts of audio and music with a view to build a public database of music recordings from a wide variety of styles and different cultures.'
const $ceab237e06e82e44$var$WELCOME_VIDEO = `<div id="landing-video-container" class="fullscreen-video-container">
    <video playsinline autoplay loop muted>
      <source src="${$ceab237e06e82e44$var$homeVideoUrl}">
    </video>  
  <div class='fullscreen-video-content'>
    <div class="typewriter">
      <h1>Welcome!</h1>      
    </div>
    <div class="h-100 d-flex">
      <div class="m-auto">
        <a id="start-link" class="btn btn-link" href="/login.html" role="button"><b>LET'S JAM?</b></a>
      </div>
    </div>    
  </div>
</div>`;
const $ceab237e06e82e44$export$c1504dbc5bdba629 = ()=>{
    document.getElementById("userlogin").innerHTML = `<li class='nav-item'>
        <a class='dropdown-item' href='${window.location.origin}/login.html'>Register / Login</a>
    </li>
    <li class='nav-item'>
        <a class='dropdown-item' href='${0, $ce4a593b0ea78dcf$export$5e4b5ab8660ba9d5}demopage'>Test DAW</a>
    </li>
    <li class='nav-item'>
        <a class='dropdown-item' href='${window.location.origin}/static/howto.html'>How-To</a>
    </li>
    <li class='nav-item'>
        <a class='dropdown-item' href='${window.location.origin}/static/news.html'>News</a>
    </li>
    `;
    document.getElementById("useroptions").innerHTML = `<li class='nav-item'>
      <a class='nav-link' href='${window.location.origin + "/profile.html"}'>Profile <i id='display_profile_name'></i></a>
    </li>
    <li class='nav-item'>
          <a class='nav-link' href='#' id='createNewButton' data-toggle='modal' data-target='#newMusicModal'>/ Create new</a>
    </li>
    <li class='nav-item'>
        <a class='nav-link' href='#' id='openMyCollectionsButton' data-toggle='modal' data-target='#editCollectionsModal'>/ My Collections</a>
    </li>
    <li class='nav-item'>
        <a class='nav-link' href='${window.location.origin + "/static/howto.html"}'>/ How-to</a>
    </li>
    <li class='nav-item'>
        <a class='nav-link' href='${window.location.origin}/static/news.html'>/ News</a>
    </li>
    `;
};
const $ceab237e06e82e44$export$bca9dffb57f7792b = (numberGroupsByCollections, numberGroupsCustom, numberSinglComp, endpoint, totalcomps)=>{
    const displayGroupsByLabel = numberGroupsByCollections || !(0, $69dccf2381da1e7e$export$1badf4b56a2f2c08)(endpoint) && numberGroupsCustom || numberSinglComp;
    return `<ul class="nav justify-content-end">
              ${displayGroupsByLabel ? '<li class="legenditem nav-item"><h4><span class="badge badge-light">Groups by:&nbsp;</span></h4></li>' : ""}
              ${numberGroupsByCollections ? '<li class="legenditem nav-item"><h4><span class="badge badge-collection">Collections&nbsp;<span id="totalcollectionsbadge" class="badge badge-light">' + numberGroupsByCollections + "</span></span></h4></li>" : ""}            
              ${!(0, $69dccf2381da1e7e$export$1badf4b56a2f2c08)(endpoint) && numberGroupsCustom ? '<li class="legenditem nav-item"><h4><span class="badge badge-warning">Users&nbsp;<span class="badge badge-light">' + numberGroupsCustom + "</span></span></h4></li>" : ""}
              ${numberSinglComp ? '<li class="legenditem nav-item"><h4><span class="badge badge-success">Singles&nbsp;<span class="badge badge-light">' + numberSinglComp + "</span></span></h4></li>" : ""}
              <li class="legenditem nav-item"><h4><span class="badge badge-light">Total compositions:&nbsp;</span><span id="totalcompositionsbadge" class="badge badge-light">${totalcomps}</span></h4></li>
            </ul>`;
};
const $ceab237e06e82e44$export$1f60eb8703988013 = (listElelemts, legendButtons)=>{
    document.getElementById("grid").innerHTML = "";
    document.getElementById("grid").insertAdjacentHTML("afterbegin", listElelemts);
    document.getElementById("legendbuttons").innerHTML = "";
    document.getElementById("legendbuttons").insertAdjacentHTML("afterbegin", legendButtons);
    document.getElementById("searchInput").removeAttribute("disabled");
};
const $ceab237e06e82e44$export$971becedf6ebeceb = (element, endpoint)=>{
    var _element_tracks_, _element_tracks, _element_tracks1;
    const displayName = (0, $69dccf2381da1e7e$export$a04c3fad920d835e)(endpoint, element.username);
    const displayNumCollabs = element.contributors.length;
    const last_track = element === null || element === void 0 ? void 0 : (_element_tracks_ = element.tracks[(element === null || element === void 0 ? void 0 : element.tracks.length) - 1]) === null || _element_tracks_ === void 0 ? void 0 : _element_tracks_.uuid;
    return `<div class='card border-success'>                       
              <div class="card-body">
              ${(0, $ce4a593b0ea78dcf$export$4cd34456ac1eb639) ? `<span class="badge ${(0, $jXEky.PRIVACY_BADGE_STYLE)[element.privacy]}">${(0, $jXEky.PRIVACY_BADGE_TEXT)[element.privacy]}</span>` : ""}
              ${element.opentocontrib ? '<p class="badge badge-info">OPEN TO CONTRIB</p>' : ""}
              ${element.is_template ? '<p class="badge badge-template">TEMPLATE</p>' : ""}  
                  <div>
                    <p class="list-group-item-heading">  
                      <a href='${(0, $ce4a593b0ea78dcf$export$5e4b5ab8660ba9d5) + element.uuid}' class='card-url'>
                        <h5 class='card-title'>${element.title}</h5>
                      </a>
                    </p>
                    <p>${displayName ? `<span class="d-inline-block text-truncate" style="max-width: 250px;">
                        <i class='fa fa-user'></i>&nbsp;
                        <a href='${(0, $jXEky.uriUserPage) + element.owner_uuid}' class='card-url'>
                          ${element.username}&nbsp;
                        </a>
                      </span>` : ""}
                    </p>
                    <p class='text-black-50'>${displayNumCollabs ? "Collaborators: " + displayNumCollabs : ""}</p>
                    <p class='card-text text-truncate'>${element.description || ""}</p>
                    ${((_element_tracks = element.tracks) === null || _element_tracks === void 0 ? void 0 : _element_tracks.length) ? `<span class="play-control-card d-inline-block text-truncate" style="max-width: 200px;" ${last_track ? ` data-trackid="${last_track}"` : ""}>
                      <i class='fa fa-play'>&nbsp;</i>Play last added track </span>&nbsp;` : ""}
                    <span class="d-inline-block text-truncate" style="max-width: 250px;">
                        <i class='fa fa-music'></i>&nbsp;${"Tracks: " + ((_element_tracks1 = element.tracks) === null || _element_tracks1 === void 0 ? void 0 : _element_tracks1.length)}
                    </span>
                  </div>                
              </div>            
          </div>`;
};
const $ceab237e06e82e44$export$cbdc54c51b649c98 = (item, typebadge, endpoint)=>{
    var _item_tracks_, _item_tracks, _item_tracks1;
    const displayName = (0, $69dccf2381da1e7e$export$a04c3fad920d835e)(endpoint, item.username);
    const displayNumCollabs = item.contributors.length;
    const last_track = item === null || item === void 0 ? void 0 : (_item_tracks_ = item.tracks[(item === null || item === void 0 ? void 0 : item.tracks.length) - 1]) === null || _item_tracks_ === void 0 ? void 0 : _item_tracks_.uuid;
    return `<div class="list-group-item ">
              ${(0, $ce4a593b0ea78dcf$export$4cd34456ac1eb639) ? `<span class="badge ${(0, $jXEky.PRIVACY_BADGE_STYLE)[item.privacy]}">${(0, $jXEky.PRIVACY_BADGE_TEXT)[item.privacy]}</span>` : ""}
              ${item.opentocontrib ? '<span class="badge badge-info">OPEN TO CONTRIB</span>' : ""}
              ${item.is_template ? '<span class="badge badge-template">TEMPLATE</span>' : ""}  
              <p class="list-group-item-heading">
                <a href='${(0, $ce4a593b0ea78dcf$export$5e4b5ab8660ba9d5) + item.uuid}' class='card-url'>
                    <h5 class='card-title'>${item.title}</h5>
                </a>
              </p>
              ${typebadge !== "user" && displayName ? '<p><span class="d-inline-block text-truncate" style="max-width: 220px;"><i class="fa fa-user"></i>&nbsp;<a href=' + (0, $jXEky.uriUserPage) + item.owner_uuid + ' class="card-url">' + item.username + "&nbsp;" + "</a>" + "</span></p>" : ""}
              <p class='text-black-50'>${displayNumCollabs ? "Collaborators: " + displayNumCollabs : ""}</p>
              <p class="list-group-item-text text-truncate">
                ${item.description || ""}
              </p>
              ${((_item_tracks = item.tracks) === null || _item_tracks === void 0 ? void 0 : _item_tracks.length) ? `<span class="play-control-card d-inline-block text-truncate" style="max-width: 200px;" ${last_track ? ` data-trackid="${last_track}"` : ""}>
                <i class='fa fa-play'>&nbsp;</i>Play last added track 
              </span>&nbsp;` : ""}
              <span class="d-inline-block text-truncate" style="max-width: 200px;">
                <i class='fa fa-music'></i>&nbsp;${"Tracks: " + ((_item_tracks1 = item.tracks) === null || _item_tracks1 === void 0 ? void 0 : _item_tracks1.length)}
              </span>
            </div>`;
};
const $ceab237e06e82e44$export$da2a595be284078a = (typebadge, numitems, groupTitle, groupId, listgroup)=>{
    const badegstyle = $ceab237e06e82e44$var$CARD_BADGE_STYLE[typebadge];
    const borderstyle = $ceab237e06e82e44$var$CARD_BORDER_STYLE[typebadge];
    const url = $ceab237e06e82e44$var$URI_PAGE[typebadge];
    const badgeDisplayed = `<span class="badge ${badegstyle} d-inline-block text-truncate" style="max-width:85%;">
                              <span class="badge badge-light">${numitems}</span>&nbsp;
                              ${url ? `<a href=${url + groupId} class="card-header-url">${groupTitle}</a>` : `${groupTitle}`}                              
                          </span>`;
    return `<div id='${groupId}' class='card ${borderstyle}'>                        
              <h4>${badgeDisplayed}</h4>        
              <div class="card-body">
                <div class="list-group border">              
                  ${listgroup}
                </div>
              </div>
            </div>`;
};
const $ceab237e06e82e44$export$2ccaa4a069104255 = (hidetext, withScroll)=>{
    var _welcomecontainer_lastChild, _welcomecontainer_lastChild1;
    const welcomecontainer = document.getElementById("welcomecontainer");
    const videoContainer = document.getElementById("landing-video-container");
    if (((_welcomecontainer_lastChild = welcomecontainer.lastChild) === null || _welcomecontainer_lastChild === void 0 ? void 0 : _welcomecontainer_lastChild.id) && ((_welcomecontainer_lastChild1 = welcomecontainer.lastChild) === null || _welcomecontainer_lastChild1 === void 0 ? void 0 : _welcomecontainer_lastChild1.id) !== "welcometext") welcomecontainer.removeChild(welcomecontainer.lastChild);
    if (!hidetext && !welcomecontainer.lastChild && !videoContainer) {
        const welcometextelem = document.createElement("div");
        welcometextelem.id = "welcometext";
        welcometextelem.innerHTML = (0, $ce4a593b0ea78dcf$export$4cd34456ac1eb639) ? "" : `${$ceab237e06e82e44$var$WELCOME_VIDEO}`;
        document.getElementById("welcomecontainer").appendChild(welcometextelem);
    }
    if (withScroll) document.getElementById("grid").scrollIntoView({
        behavior: "smooth"
    });
};
const $ceab237e06e82e44$export$206832d47f4d1079 = (collectiontitle, username, owner_uuid)=>{
    $ceab237e06e82e44$export$2ccaa4a069104255(true);
    const collectionInfoContainer = document.createElement("div");
    collectionInfoContainer.id = "infocontainer";
    collectionInfoContainer.innerHTML = `<div class="card border-collection mb-3">
                                          <div class="card-header bg-transparent border-collection"><b>Collection</b></div>
                                          <div class="card-body text-dark">
                                            <h5 class="card-title">${collectiontitle}</h5>
                                            <p class="card-text" style="width:300px;">Holder: <a href=${(0, $jXEky.uriUserPage) + owner_uuid} class="card-url">${username}</a></p>
                                          </div>
                                        </div>`;
    document.getElementById("welcomecontainer").appendChild(collectionInfoContainer);
};
const $ceab237e06e82e44$export$b8abf8ca7249a7d2 = (username, useruid)=>{
    $ceab237e06e82e44$export$2ccaa4a069104255(true);
    const userInfoContainer = document.createElement("div");
    userInfoContainer.id = "infocontainer";
    userInfoContainer.innerHTML = `<div class="card mb-3" style="max-width: 540px;">
                                    <div class="row no-gutters">
                                      <div class="col-md-4">
                                        <img class="img-fluid hidden-first" src="https://picsum.photos/seed/${useruid}/200" alt="User Picture" width="200" height="200">
                                      </div>
                                      <div class="col-md-8">
                                        <div class="card-body">
                                          <h5 class="card-title">User</h5>
                                          <p class="card-text" style="width:300px;">${username ? `${username}` : ""}</p>                                        
                                          <p class="card-text"><small class="text-muted"></small></p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>`;
    document.getElementById("welcomecontainer").appendChild(userInfoContainer);
};




let $299b0bf5dfda9fee$var$tracks_dictionary = null;
let $299b0bf5dfda9fee$var$composition_dictionary = null;
let $299b0bf5dfda9fee$var$AUTO_PLAY = false;
let $299b0bf5dfda9fee$var$wavesurfer = null;
let $299b0bf5dfda9fee$var$currentAbortController = null;
const $299b0bf5dfda9fee$var$waveSurferOptions = {
    container: "#waveform",
    responsive: true,
    height: 80,
    waveColor: "#007bff",
    progressColor: "#6610f2",
    barWidth: 2,
    barGap: 1,
    barRadius: 2,
    cursorWidth: 0
};
const $299b0bf5dfda9fee$var$getCurrentTrack = ()=>{
    const audio = document.getElementById("waveform");
    const currentTrack = audio.getAttribute("data-currentaudio");
    return currentTrack;
};
const $299b0bf5dfda9fee$var$changeFaIcon = (trackid, startPlaying)=>{
    var _document_querySelector;
    const iconElement = (_document_querySelector = document.querySelector(`[data-trackid='${trackid}']`)) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.firstChild.nextSibling;
    if (iconElement) {
        if (startPlaying) iconElement.classList.replace("fa-play", "fa-volume-down");
        else {
            iconElement.classList.replace("fa-volume-down", "fa-play");
            iconElement.classList.remove("fa-beat");
        }
    }
};
const $299b0bf5dfda9fee$var$changeFloatingIcon = (startPlaying)=>{
    const floatingPlayButton = document.getElementById("playfloatingbutton").firstChild.nextSibling;
    if (startPlaying) {
        floatingPlayButton.classList.remove("fa-play");
        floatingPlayButton.classList.add("fa-pause");
    } else {
        floatingPlayButton.classList.remove("fa-pause");
        floatingPlayButton.classList.add("fa-play");
    }
};
const $299b0bf5dfda9fee$var$clickOnSameTrack = ()=>{
    const isPlaying = $299b0bf5dfda9fee$var$wavesurfer.isPlaying();
    if (!isPlaying) $299b0bf5dfda9fee$var$wavesurfer.play();
    else $299b0bf5dfda9fee$var$wavesurfer.pause();
};
const $299b0bf5dfda9fee$var$checkAudioPausedNotSameTrack = (trackid)=>{
    const isPlaying = $299b0bf5dfda9fee$var$wavesurfer === null || $299b0bf5dfda9fee$var$wavesurfer === void 0 ? void 0 : $299b0bf5dfda9fee$var$wavesurfer.isPlaying();
    if (isPlaying) {
        $299b0bf5dfda9fee$var$changeFaIcon(trackid, false);
        $299b0bf5dfda9fee$var$wavesurfer.pause();
    }
};
const $299b0bf5dfda9fee$var$playTrackButtonHandler = (trackid)=>{
    if (document.getElementById("sticky-player").hidden) document.getElementById("sticky-player").hidden = false;
    const currentTrack = $299b0bf5dfda9fee$var$getCurrentTrack();
    let is_same_track = currentTrack === trackid;
    if (is_same_track) $299b0bf5dfda9fee$var$clickOnSameTrack();
    else {
        $299b0bf5dfda9fee$var$changeFaIcon(currentTrack, false);
        $299b0bf5dfda9fee$var$checkAudioPausedNotSameTrack(trackid);
        $299b0bf5dfda9fee$var$loadAudioTrack(trackid, true);
    }
};
const $299b0bf5dfda9fee$var$loadTrackSuccess = (audioSrc, doPlay)=>{
    $299b0bf5dfda9fee$var$AUTO_PLAY = doPlay;
    $299b0bf5dfda9fee$var$wavesurfer.seekTo(0);
    $299b0bf5dfda9fee$var$wavesurfer.load(audioSrc);
};
const $299b0bf5dfda9fee$var$loadTrackError = (trackid, error)=>{
    const playElemUI = document.querySelector(`[data-trackid='${trackid}']`);
    if (playElemUI) {
        playElemUI.onclick = null;
        const iconElement = playElemUI.firstChild.nextSibling;
        iconElement.classList.remove("fa-volume-down");
        iconElement.classList.remove("fa-beat");
        iconElement.classList.add("fa-times");
    }
    $299b0bf5dfda9fee$var$changeFloatingIcon(false);
    const trackInfo = $299b0bf5dfda9fee$var$getTrackInfo(trackid);
    document.getElementById("current-play-info").textContent = " Error loading track at: " + trackInfo.comp_title;
    $299b0bf5dfda9fee$var$wavesurfer.destroy();
};
const $299b0bf5dfda9fee$var$updateCurrentPlayInfo = (track_id)=>{
    const trackInfo = $299b0bf5dfda9fee$var$getTrackInfo(track_id);
    document.getElementById("current-play-info").textContent = trackInfo.comp_title + " / " + trackInfo.track_title;
};
const $299b0bf5dfda9fee$var$getTrackInfo = (track_id)=>{
    const track_title = $299b0bf5dfda9fee$var$tracks_dictionary[track_id].title;
    const comp_title = $299b0bf5dfda9fee$var$composition_dictionary[$299b0bf5dfda9fee$var$tracks_dictionary[track_id].comp_uuid].title;
    return {
        track_title: track_title,
        comp_title: comp_title
    };
};
const $299b0bf5dfda9fee$export$144cd45dcb767075 = (compositionsList)=>{
    const all_tracks = (0, $69dccf2381da1e7e$export$3763f15547b21628)(compositionsList);
    if (all_tracks.tracksList.length) {
        document.querySelector(".sticky-container").style.display = "block";
        $299b0bf5dfda9fee$var$tracks_dictionary = all_tracks.tracksDictionary;
        $299b0bf5dfda9fee$var$composition_dictionary = all_tracks.compositionsDictionary;
    }
};
const $299b0bf5dfda9fee$var$loadAudioTrack = async (trackid, doPlay)=>{
    if ($299b0bf5dfda9fee$var$wavesurfer) {
        $299b0bf5dfda9fee$var$unsubscribeEvents();
        $299b0bf5dfda9fee$var$wavesurfer.destroy();
    }
    $299b0bf5dfda9fee$var$wavesurfer = $299b0bf5dfda9fee$var$initializeWavesurfer();
    $299b0bf5dfda9fee$var$addEventHandlersToWavesurfer();
    const audio = document.getElementById("waveform");
    audio.setAttribute("data-currentaudio", trackid);
    document.getElementById("current-play-info").textContent = "Downloading track ... 0%";
    const floatingPlayButton = document.getElementById("playfloatingbutton");
    floatingPlayButton.classList.add("isDisabled");
    const audioSrc = window.location.origin + "/trackfile/" + trackid;
    if ($299b0bf5dfda9fee$var$currentAbortController) $299b0bf5dfda9fee$var$currentAbortController.abort();
    $299b0bf5dfda9fee$var$currentAbortController = new AbortController();
    const signal = $299b0bf5dfda9fee$var$currentAbortController.signal;
    const response = await fetch(audioSrc, {
        signal: signal
    });
    if (response.ok) $299b0bf5dfda9fee$var$loadTrackSuccess(audioSrc, doPlay);
    else $299b0bf5dfda9fee$var$loadTrackError(trackid, "Fetching error");
};
const $299b0bf5dfda9fee$export$7a196286caa95f25 = ()=>{
    const elements = document.querySelectorAll("[data-trackid]");
    elements.forEach((element)=>{
        const trackid = element.getAttribute("data-trackid");
        element.onclick = ()=>{
            $299b0bf5dfda9fee$var$playTrackButtonHandler(trackid);
        };
    });
};
const $299b0bf5dfda9fee$var$fabPlayButtonIsCurrentTrack = ()=>{
    const isPlaying = $299b0bf5dfda9fee$var$wavesurfer.isPlaying();
    if (isPlaying) $299b0bf5dfda9fee$var$wavesurfer.pause();
    else $299b0bf5dfda9fee$var$wavesurfer.play();
};
const $299b0bf5dfda9fee$export$ddb3bbf4ed6f1ca3 = ()=>{
    const floatingPlayButton = document.getElementById("playfloatingbutton");
    floatingPlayButton.onclick = ()=>{
        $299b0bf5dfda9fee$var$fabPlayButtonIsCurrentTrack();
    };
};
const $299b0bf5dfda9fee$var$initializeWavesurfer = ()=>{
    return WaveSurfer.create($299b0bf5dfda9fee$var$waveSurferOptions);
};
const $299b0bf5dfda9fee$var$unsubscribeEvents = ()=>{
    $299b0bf5dfda9fee$var$wavesurfer.unAll();
};
const $299b0bf5dfda9fee$var$addEventHandlersToWavesurfer = ()=>{
    $299b0bf5dfda9fee$var$wavesurfer.on("finish", ()=>{
        const currentTrack = $299b0bf5dfda9fee$var$getCurrentTrack();
        $299b0bf5dfda9fee$var$changeFloatingIcon(false);
        $299b0bf5dfda9fee$var$changeFaIcon(currentTrack, false);
    });
    $299b0bf5dfda9fee$var$wavesurfer.on("play", ()=>{
        const currentTrack = $299b0bf5dfda9fee$var$getCurrentTrack();
        $299b0bf5dfda9fee$var$changeFloatingIcon(true);
        $299b0bf5dfda9fee$var$changeFaIcon(currentTrack, true);
    });
    $299b0bf5dfda9fee$var$wavesurfer.on("loading", (percentage)=>{
        document.getElementById("current-play-info").textContent = `Downloading track ... ${percentage}%`;
    });
    $299b0bf5dfda9fee$var$wavesurfer.on("pause", ()=>{
        const currentTrack = $299b0bf5dfda9fee$var$getCurrentTrack();
        $299b0bf5dfda9fee$var$changeFloatingIcon(false);
        $299b0bf5dfda9fee$var$changeFaIcon(currentTrack, false);
    });
    $299b0bf5dfda9fee$var$wavesurfer.on("ready", (duration)=>{
        const floatingPlayButton = document.getElementById("playfloatingbutton");
        floatingPlayButton.classList.remove("isDisabled");
        const currentTrack = $299b0bf5dfda9fee$var$getCurrentTrack();
        $299b0bf5dfda9fee$var$updateCurrentPlayInfo(currentTrack);
        if ($299b0bf5dfda9fee$var$AUTO_PLAY) $299b0bf5dfda9fee$var$wavesurfer.play();
        else $299b0bf5dfda9fee$var$changeFloatingIcon(false);
    });
    $299b0bf5dfda9fee$var$wavesurfer.on("error", (error)=>{
        if (error) {
            const currentTrack = $299b0bf5dfda9fee$var$getCurrentTrack();
            $299b0bf5dfda9fee$var$loadTrackError(currentTrack, error);
        }
    });
};


const $ce4a593b0ea78dcf$export$5e4b5ab8660ba9d5 = "/composition.html?compositionId=";
let $ce4a593b0ea78dcf$export$4cd34456ac1eb639 = false;
const $ce4a593b0ea78dcf$var$homePageTermsAccepted = (termsAccepted)=>{
    if (!termsAccepted) (0, $faZmx.generateAcceptTermsModal)("header");
};
const $ce4a593b0ea78dcf$var$getMyProfile = async ()=>{
    const isAuthenticated = await (0, $jXEky.callJsonApi)("/profile", "GET", null, "Loading profile...");
    if (isAuthenticated.ok) {
        (0, $69dccf2381da1e7e$export$149136365741a43c)(isAuthenticated.name);
        document.getElementById("userlogin").style.display = "none";
        document.getElementById("useroptions").style.display = "";
        document.getElementById("display_profile_name").innerText = `[${isAuthenticated.name}]`;
        (0, $faZmx.checkIfTermsAccepted)(isAuthenticated, $ce4a593b0ea78dcf$var$homePageTermsAccepted);
    }
    return isAuthenticated;
};
const $ce4a593b0ea78dcf$export$b99e48ec291af6c0 = async ()=>{
    const endpoint = "/mycompositions";
    const data = await (0, $jXEky.callJsonApi)(endpoint, "GET", null, "Loading my music...");
    if (data.compositions) return $ce4a593b0ea78dcf$var$renderHomePage(data.compositions, endpoint);
    else alert("invalid return value for compisitions list");
};
const $ce4a593b0ea78dcf$var$getCompositionsByUserUid = async (useruid, auth)=>{
    const endpoint = "/compositionsbyuserid/" + useruid;
    const data = await (0, $jXEky.callJsonApi)(endpoint, "GET", null, "Loading user...");
    if (data.compositions) {
        (0, $69dccf2381da1e7e$export$149136365741a43c)(data.username);
        (0, $ceab237e06e82e44$export$b8abf8ca7249a7d2)(data.username, useruid);
        return $ce4a593b0ea78dcf$var$renderHomePage(data.compositions, endpoint);
    } else {
        alert("invalid return value for user id");
        if (auth.ok) (0, $a57243222c2ea8a4$export$ff7962acd6052c28)("my-comp");
        else (0, $a57243222c2ea8a4$export$ff7962acd6052c28)("recent-comp");
    }
};
const $ce4a593b0ea78dcf$var$getCompositionsByColelctionUid = async (collectionuid, auth)=>{
    const endpoint = "/collectionastreebyid/" + collectionuid;
    const data = await (0, $jXEky.callJsonApi)(endpoint, "GET", null, "Loading collection...");
    if (data.compositions) {
        (0, $69dccf2381da1e7e$export$149136365741a43c)(data.username);
        (0, $ceab237e06e82e44$export$206832d47f4d1079)(data.collection_name, data.username, data.owneruid);
        return $ce4a593b0ea78dcf$var$renderHomePage(data.compositions, endpoint);
    } else {
        alert("invalid return value for collection id");
        if (auth.ok) (0, $a57243222c2ea8a4$export$ff7962acd6052c28)("my-comp");
        else (0, $a57243222c2ea8a4$export$ff7962acd6052c28)("recent-comp");
    }
};
const $ce4a593b0ea78dcf$export$8d85b36da8527a05 = async (withScroll)=>{
    const endpoint = "/recentcompositions";
    const data = await (0, $jXEky.callJsonApi)("/recentcompositions", "GET", null, "Loading recent...");
    return $ce4a593b0ea78dcf$var$renderHomePage((data === null || data === void 0 ? void 0 : data.compositions) || [], endpoint, withScroll);
};
const $ce4a593b0ea78dcf$export$556539c2d93a797d = async (withScroll)=>{
    const endpoint = "/compositions";
    const data = await (0, $jXEky.callJsonApi)("/compositions", "GET", null, "Loading all...");
    return $ce4a593b0ea78dcf$var$renderHomePage((data === null || data === void 0 ? void 0 : data.compositions) || [], endpoint, withScroll);
};
const $ce4a593b0ea78dcf$var$renderHomePage = (compositionsList, endpoint, withScroll)=>{
    document.getElementById("grid").innerHTML = "";
    document.getElementById("legendbuttons").innerHTML = "";
    const notUserPublicPage = !endpoint.includes("/compositionsbyuserid/") && !endpoint.includes("/collectionastreebyid/");
    if (notUserPublicPage) (0, $ceab237e06e82e44$export$2ccaa4a069104255)(false, withScroll);
    if (!compositionsList.length && notUserPublicPage) {
        document.getElementById("initialmessage").hidden = false;
        document.getElementById("initialmessage").classList.add("d-flex");
    } else $ce4a593b0ea78dcf$var$renderHomePageWithLists(compositionsList, endpoint);
    (0, $299b0bf5dfda9fee$export$144cd45dcb767075)(compositionsList);
    (0, $299b0bf5dfda9fee$export$7a196286caa95f25)();
};
const $ce4a593b0ea78dcf$var$renderHomePageWithLists = (compositionsList, endpoint)=>{
    if (endpoint.includes("/collectionastreebyid/")) {
        const parent_coll_id = endpoint.replace("/collectionastreebyid/", "");
        const groupedCompsAndSubColl = (0, $69dccf2381da1e7e$export$46ab7a802f6f7711)(compositionsList, parent_coll_id);
        $ce4a593b0ea78dcf$var$paintListOfCompositions(groupedCompsAndSubColl, null, endpoint, compositionsList.length);
    } else if (!(0, $69dccf2381da1e7e$export$1badf4b56a2f2c08)(endpoint)) {
        const groupedComps = (0, $69dccf2381da1e7e$export$2095d3815b0f7547)(compositionsList);
        $ce4a593b0ea78dcf$var$paintListOfCompositions(groupedComps, "groupedbyuser_final", endpoint, compositionsList.length);
    } else {
        const groupedCompsWithCollab = (0, $69dccf2381da1e7e$export$6d37f804b553eac7)(compositionsList);
        $ce4a593b0ea78dcf$var$paintListOfCompositions(groupedCompsWithCollab, "groupedbycollab", endpoint, compositionsList.length);
    }
};
const $ce4a593b0ea78dcf$var$paintGroupCollection = (listcomps, typebadge, endpoint)=>{
    let allCompUIelem = "";
    for(const comp in listcomps){
        const element = listcomps[comp];
        let listgroup = "";
        let groupTitle = "";
        let groupId = null;
        if (typebadge === "collab") groupTitle = "Collaborations";
        else if (typebadge === "coll") {
            groupTitle = Object.values(element)[0].parent_collection;
            groupId = Object.values(element)[0].collection_uid;
        } else {
            groupTitle = Object.values(element)[0].username;
            groupId = Object.values(element)[0].owner_uuid;
        }
        for (const item of element)listgroup += (0, $ceab237e06e82e44$export$cbdc54c51b649c98)(item, typebadge, endpoint);
        allCompUIelem += (0, $ceab237e06e82e44$export$da2a595be284078a)(typebadge, element.length, groupTitle, groupId, listgroup);
    }
    return allCompUIelem;
};
const $ce4a593b0ea78dcf$var$getSingleComps = (groupedComps, endpoint)=>{
    let listElelemts = "";
    const listCompsSingle = groupedComps.singlecomps;
    listCompsSingle === null || listCompsSingle === void 0 ? void 0 : listCompsSingle.forEach((element)=>{
        const template = (0, $ceab237e06e82e44$export$971becedf6ebeceb)(element, endpoint);
        listElelemts += template;
    });
    return listElelemts;
};
const $ce4a593b0ea78dcf$var$paintListOfCompositions = (groupedComps, customgroup, endpoint, totalcomps)=>{
    let listElelemts = "";
    const numberGroupsByCollections = Object.keys(groupedComps.groupedbycoll).length;
    const numberCustomGroups = customgroup ? Object.keys(groupedComps[customgroup]).length : 0;
    let numberSinglComp = groupedComps.singlecomps.length;
    if (numberGroupsByCollections > 0) {
        const listComps = groupedComps.groupedbycoll;
        const template = $ce4a593b0ea78dcf$var$paintGroupCollection(listComps, "coll", endpoint);
        listElelemts += template;
    }
    if (numberCustomGroups > 0) {
        const listComps = groupedComps[customgroup];
        const typeofbadge = customgroup === "groupedbycollab" ? "collab" : "user";
        const template = $ce4a593b0ea78dcf$var$paintGroupCollection(listComps, typeofbadge, endpoint);
        listElelemts += template;
    }
    if (numberSinglComp > 0) listElelemts += $ce4a593b0ea78dcf$var$getSingleComps(groupedComps, endpoint);
    const legendButtons = (0, $ceab237e06e82e44$export$bca9dffb57f7792b)(numberGroupsByCollections, numberCustomGroups, numberSinglComp, endpoint, totalcomps);
    (0, $ceab237e06e82e44$export$1f60eb8703988013)(listElelemts, legendButtons);
};
const $ce4a593b0ea78dcf$var$initHomPage = async ()=>{
    const queryString = window.location.search;
    const user_id = queryString.split("userid=")[1];
    const collection_uid = queryString.split("collectionid=")[1];
    let isAuth = await $ce4a593b0ea78dcf$var$getMyProfile();
    $ce4a593b0ea78dcf$export$4cd34456ac1eb639 = isAuth.ok;
    if (user_id) await $ce4a593b0ea78dcf$var$getCompositionsByUserUid(user_id, isAuth);
    else if (collection_uid) await $ce4a593b0ea78dcf$var$getCompositionsByColelctionUid(collection_uid, isAuth);
    else if (isAuth.ok) await $ce4a593b0ea78dcf$export$b99e48ec291af6c0();
    else await $ce4a593b0ea78dcf$export$8d85b36da8527a05();
    (0, $a57243222c2ea8a4$export$184163c68675dcce)(isAuth, user_id || collection_uid);
};
(0, $ceab237e06e82e44$export$c1504dbc5bdba629)();
(0, $jXEky.activateGoHomeLink)();
$ce4a593b0ea78dcf$var$initHomPage();
(0, $299b0bf5dfda9fee$export$ddb3bbf4ed6f1ca3)();



var $fZ0Rm = parcelRequire("fZ0Rm");

var $hbluw = parcelRequire("hbluw");

let $14282b8b27bf399a$var$EDIT_STATUS = false;
const $14282b8b27bf399a$var$showAllCollButton = document.getElementById("openMyCollectionsButton");
const $14282b8b27bf399a$var$editButton = document.getElementById("editmycollectionsbutton");
const $14282b8b27bf399a$var$fetchCollectionsTree = async ()=>{
    const response = await fetch("/mycollectionsastree");
    const data = await response.json();
    return data;
};
const $14282b8b27bf399a$var$createTreeHTML = (item)=>{
    let html = `
        <span id='removeCollIcon${item.uuid}' data-uuid='${item.uuid}' data-title='${item.title}' role='button' class='badge badge-pill badge-danger' hidden>-</span>
        <li id='${item.uuid}' class='list-group-item border-bottom-0 border-right-0 border-top-0 border-warning'>
            <input type='text' class='form-control border-secondary' id='treecolltitleinput${item.uuid}' data-uuid='${item.uuid}' placeholder='Type a new title'
            title='collectiontitle' value='${item.title}' disabled>
        </li>`;
    if (item.compositions.length > 0 || item.collections.length > 0) {
        html += "<ul>";
        for (const composition of item.compositions)html += `<li class='list-group-item border-0'><a href='${(0, $ce4a593b0ea78dcf$export$5e4b5ab8660ba9d5) + composition.uuid}'><u>${composition.title}</u></a></li>`;
        for (const collection of item.collections)html += $14282b8b27bf399a$var$createTreeHTML(collection);
        html += "</ul>";
    }
    return html;
};
const $14282b8b27bf399a$var$renderTree = async ()=>{
    const treeContainer = document.getElementById("listCollContainerAllColl");
    const data = await $14282b8b27bf399a$var$fetchCollectionsTree();
    let html = "<ul>";
    for (const collection of data)html += $14282b8b27bf399a$var$createTreeHTML(collection);
    html += "</ul>";
    treeContainer.innerHTML = html;
};
const $14282b8b27bf399a$var$clickEditButtonHandler = ()=>{
    if ($14282b8b27bf399a$var$EDIT_STATUS) {
        $14282b8b27bf399a$var$EDIT_STATUS = false;
        $14282b8b27bf399a$var$editButton.innerText = "Edit";
        $14282b8b27bf399a$var$disableEdition();
    } else {
        $14282b8b27bf399a$var$EDIT_STATUS = true;
        $14282b8b27bf399a$var$editButton.innerText = "Done";
        $14282b8b27bf399a$var$enableEdition();
    }
};
const $14282b8b27bf399a$var$enableEdition = ()=>{
    const elementsWithHiddenAttribute = document.querySelectorAll(`[id*='removeCollIcon']`);
    elementsWithHiddenAttribute.forEach((element)=>{
        element.removeAttribute("hidden");
        $14282b8b27bf399a$var$removeCollectionClickhHandler(element.getAttribute("data-uuid"), element.getAttribute("data-title"));
    });
    const elementsWithDisabledAttribute = document.querySelectorAll(`[id*='treecolltitleinput']`);
    elementsWithDisabledAttribute.forEach((element)=>{
        element.removeAttribute("disabled");
        $14282b8b27bf399a$var$updateInputTextEventHandler(element.getAttribute("data-uuid"), element.value);
    });
};
const $14282b8b27bf399a$var$disableEdition = ()=>{
    const elementsWithHiddenAttribute = document.querySelectorAll(`[id*='removeCollIcon']`);
    elementsWithHiddenAttribute.forEach((element)=>{
        element.setAttribute("hidden", "true");
    });
    const elementsWithDisabledAttribute = document.querySelectorAll(`[id*='treecolltitleinput']`);
    elementsWithDisabledAttribute.forEach((element)=>{
        element.setAttribute("disabled", "true");
    });
};
const $14282b8b27bf399a$var$clickAllCollButtonHandler = async ()=>{
    $14282b8b27bf399a$var$EDIT_STATUS = false;
    $14282b8b27bf399a$var$editButton.innerText = "Edit";
    await $14282b8b27bf399a$var$renderTree();
    $14282b8b27bf399a$var$editButton.addEventListener("click", $14282b8b27bf399a$var$clickEditButtonHandler, false);
};
$14282b8b27bf399a$var$showAllCollButton === null || $14282b8b27bf399a$var$showAllCollButton === void 0 ? void 0 : $14282b8b27bf399a$var$showAllCollButton.addEventListener("click", $14282b8b27bf399a$var$clickAllCollButtonHandler, false);
const $14282b8b27bf399a$var$confirmDeleteCollectionModal = async (event, collectionId, collectionTitle)=>{
    const chk = event.target;
    if (chk.tagName === "SPAN") {
        if (confirm(`Are you sure you want remove the collection ${collectionTitle} and all of its content?`) == true) {
            const response = await fetch((0, $hbluw.ENDPOINT) + "/deletecollection/" + collectionId, {
                method: "DELETE"
            });
            if (response === null || response === void 0 ? void 0 : response.ok) $14282b8b27bf399a$var$removeCollectionFromModalDialog(collectionId);
        } else event.target.checked = false;
    }
};
const $14282b8b27bf399a$var$removeCollectionFromModalDialog = (collectionId)=>{
    var _listElemToDelete_nextSibling;
    const totalCompBadge = document.getElementById("totalcompositionsbadge");
    let numberOfComp = parseInt(totalCompBadge === null || totalCompBadge === void 0 ? void 0 : totalCompBadge.textContent);
    const listElemToDelete = document.getElementById(collectionId);
    let coll_ids = null;
    let comp_children = 0;
    if ((listElemToDelete === null || listElemToDelete === void 0 ? void 0 : (_listElemToDelete_nextSibling = listElemToDelete.nextSibling) === null || _listElemToDelete_nextSibling === void 0 ? void 0 : _listElemToDelete_nextSibling.tagName) === "UL") {
        var _listElemToDelete_nextSibling_querySelectorAll;
        comp_children = (_listElemToDelete_nextSibling_querySelectorAll = listElemToDelete.nextSibling.querySelectorAll("a")) === null || _listElemToDelete_nextSibling_querySelectorAll === void 0 ? void 0 : _listElemToDelete_nextSibling_querySelectorAll.length;
        coll_ids = Array.from(listElemToDelete.nextSibling.querySelectorAll("li[id]")).map((li)=>li.id);
        listElemToDelete.nextSibling.remove();
    }
    listElemToDelete.remove();
    $14282b8b27bf399a$var$removeCollectionFromHomePage(collectionId);
    document.getElementById("removeCollIcon" + collectionId).remove();
    coll_ids && coll_ids.forEach((id)=>{
        $14282b8b27bf399a$var$removeCollectionFromHomePage(id);
    });
    totalCompBadge && (totalCompBadge.textContent = numberOfComp - comp_children);
    const collection_uid = window.location.search.split("collectionid=")[1];
    if (collectionId === collection_uid) window.location.href = window.location.origin;
};
const $14282b8b27bf399a$var$removeCollectionFromHomePage = (collectionId)=>{
    const cardElemToDelete = document.getElementById(collectionId);
    if (cardElemToDelete) {
        const totalCollBadge = document.getElementById("totalcollectionsbadge");
        let numberOfColl = parseInt(totalCollBadge === null || totalCollBadge === void 0 ? void 0 : totalCollBadge.textContent);
        numberOfColl--;
        totalCollBadge && (totalCollBadge.textContent = numberOfColl);
        cardElemToDelete.remove();
    }
};
const $14282b8b27bf399a$var$removeCollectionClickhHandler = (collectionId, collectionTitle)=>{
    document.getElementById("removeCollIcon" + collectionId).onclick = async (event)=>{
        await $14282b8b27bf399a$var$confirmDeleteCollectionModal(event, collectionId, collectionTitle);
    };
};
const $14282b8b27bf399a$var$updateInputTextEventHandler = (collectionId, currentTitle)=>{
    document.getElementById("treecolltitleinput" + collectionId).onblur = (event)=>{
        $14282b8b27bf399a$var$handleInputBlur(event, collectionId, currentTitle);
    };
};
const $14282b8b27bf399a$var$updateCollectionTitleRqst = (value, uuid)=>{
    const updateTitleApi = (0, $hbluw.ENDPOINT) + "/updatecolltitle";
    const data = {
        title: value,
        uuid: uuid
    };
    fetch(updateTitleApi, {
        method: "PATCH",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
    }).then().catch((error)=>{
        console.error("Error updating value:", error);
    });
};
const $14282b8b27bf399a$var$handleInputBlur = (event, collId, currTitle)=>{
    const newValue = event.target.value;
    if (currTitle !== newValue) {
        if (!newValue || newValue === "") {
            event.target.value = currTitle;
            alert("Introduce a valid title, please");
            return;
        } else $14282b8b27bf399a$var$updateCollectionTitleRqst(newValue, collId);
    }
};


const $11ef8b79751ebaff$var$createNewButton = document.getElementById("createNewButton");
const $11ef8b79751ebaff$var$createNewButtonAtHome = document.getElementById("createNewButtonAtHome");
const $11ef8b79751ebaff$var$clickNewButtonHandler = ()=>{
    if (!(0, $ce4a593b0ea78dcf$export$4cd34456ac1eb639)) window.location.href = "/login.html";
    else {
        document.getElementById("newtitle").value = "";
        document.getElementById("newdescription").value = "";
        const saveCompositionButton = document.getElementById("newcreation");
        $11ef8b79751ebaff$var$saveEventListener(saveCompositionButton);
        (0, $fZ0Rm.getCollections)().then((result)=>{
            if (result) $11ef8b79751ebaff$var$getCompCollSuccess(result);
            else (0, $fZ0Rm.getCollectionsError)();
        });
    }
};
$11ef8b79751ebaff$var$createNewButton === null || $11ef8b79751ebaff$var$createNewButton === void 0 ? void 0 : $11ef8b79751ebaff$var$createNewButton.addEventListener("click", $11ef8b79751ebaff$var$clickNewButtonHandler, false);
$11ef8b79751ebaff$var$createNewButtonAtHome === null || $11ef8b79751ebaff$var$createNewButtonAtHome === void 0 ? void 0 : $11ef8b79751ebaff$var$createNewButtonAtHome.addEventListener("click", $11ef8b79751ebaff$var$clickNewButtonHandler, false);
const $11ef8b79751ebaff$var$getCompCollSuccess = (list)=>{
    document.getElementById("listCollContainer").innerHTML = "";
    (0, $fZ0Rm.createListCollections)(list, "listCollContainer");
};
const $11ef8b79751ebaff$var$saveEventListener = (saveCompositionButton)=>{
    saveCompositionButton === null || saveCompositionButton === void 0 ? void 0 : saveCompositionButton.addEventListener("click", $11ef8b79751ebaff$var$saveEventListenerHandler);
};
const $11ef8b79751ebaff$var$saveEventListenerHandler = (e)=>{
    const newCreation = document.querySelector('input[name="newMusicTypeRadioButton"]:checked').value;
    let apiMethod = "/newcomposition";
    if (newCreation === "coll") apiMethod = "/newcollection";
    let newtitle = document.getElementById("newtitle").value;
    const privacyLevel = document.querySelector('input[name="newMusicPrivacyRadios"]:checked').value;
    if (!newtitle) {
        alert("Introduce a valid title, please");
        return;
    }
    const newdescription = document.getElementById("newdescription").value;
    const collectInput = document.getElementById("inputGroupSelectCollect");
    let parentCollection = (collectInput === null || collectInput === void 0 ? void 0 : collectInput.value) || null;
    if (parentCollection === "0") parentCollection = null;
    let body = JSON.stringify({
        title: newtitle,
        privacy_level: privacyLevel,
        parent_uuid: parentCollection,
        description: newdescription
    });
    let errorIs = null;
    (0, $jXEky.startLoader)("Creating...");
    fetch((0, $hbluw.ENDPOINT) + apiMethod, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        },
        body: body
    }).then((r)=>{
        if (!r.ok) errorIs = r.statusText;
        return r.json();
    }).then((data)=>{
        (0, $jXEky.cancelLoader)();
        if (data) $11ef8b79751ebaff$var$verifyResponse(data);
        else throw new Error(data);
    }).catch((error)=>{
        errorIs = error;
        (0, $jXEky.cancelLoader)();
    });
};
const $11ef8b79751ebaff$var$verifyResponse = (response)=>{
    $("#newMusicModal").modal("hide");
    if (response.composition) window.location.href = (0, $ce4a593b0ea78dcf$export$5e4b5ab8660ba9d5) + response.composition.uuid;
    else if (response.ok) (0, $gXFaz.default).dynamicModalDialog(`Collection created successfully!`, null, "", "Close", "New Collection", "bg-success");
    else (0, $gXFaz.default).dynamicModalDialog(`An error happened, item not created`, null, "", "Close", "Error at Creation", "bg-danger");
};


//# sourceMappingURL=index.4020d3ca.js.map
